import { render, staticRenderFns } from "./EditorProjectSelectionList.vue?vue&type=template&id=af3c84a0&scoped=true&"
import script from "./EditorProjectSelectionList.vue?vue&type=script&lang=js&"
export * from "./EditorProjectSelectionList.vue?vue&type=script&lang=js&"
import style0 from "./EditorProjectSelectionList.vue?vue&type=style&index=0&id=af3c84a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3c84a0",
  null
  
)

export default component.exports